var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.form)?_c('div',[_c('div',{staticClass:"form-tunnel",domProps:{"innerHTML":_vm._s(_vm.form)}}),_vm._v(" "+_vm._s(_vm.addValueToHiddenField())+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }